import React, { useEffect, useState } from 'react';
import { Button, Checkbox, MultiSelect } from '@ipc/ipc-components';
import FormLabel from '@material-ui/core/FormLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import PropTypes from 'prop-types';
import { primaryButton, redButton } from '../../../styles/themes';

const ImpcFilterModal = ({
  confirmHandler, dismissHandler, clearHandler, modal: { open, options }, isFiltered,
}) => {
  const [impcsOptions, updateImpcsOptions] = useState([]);
  const [selectedValues, updateSelectedValues] = useState([]);
  const [allSelected, setAllSelected] = useState(false);

  useEffect(() => {
    updateImpcsOptions(options);
  }, [options && options.length]);

  useEffect(() => {
    if ((options && options.length) === (selectedValues && selectedValues.length)) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  }, [selectedValues && selectedValues.length]);


  const modalConfirmHandler = () => {
    confirmHandler(selectedValues, impcsOptions);
  };

  const modalDismissHandler = () => {
    dismissHandler();
    updateImpcsOptions([]);
  };
  const onSelect = (event) => {
    updateSelectedValues(event);
  };

  const allImpcsCheckboxHandler = (event, value) => {
    setAllSelected(value);
    updateSelectedValues(value ? options : []);
  };
  const clearFilterHandler = () => {
    clearHandler();
    updateSelectedValues([]);
  };

  const hasSelectedValues = () => Array.isArray(selectedValues) && selectedValues.length > 0;

  return (
    <div>
      <Dialog
        open={open || false}
        onClose={modalDismissHandler}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        data-testid="modal-dialog"
        maxWidth="sm"
        className="impcFilterDialog"
      >
        <DialogTitle id="alert-dialog-title">Filter On Origin IMPC(s)</DialogTitle>
        <DialogContent>
          <FormLabel title="Filter On Origin IMPC(s)">
            <MultiSelect
              options={impcsOptions}
              value={selectedValues}
              className="Input MultiSelect"
              data-testid="filter-impc-modal"
              onChange={onSelect}
            />
          </FormLabel>
        </DialogContent>
        <div className="InLine">
          <Checkbox
            label="All IMPC(s)"
            name="allImpcs"
            onChange={allImpcsCheckboxHandler}
            checked={allSelected}
            className="CheckBox"
            disabled={options && options.length === 0}
          />
          <DialogActions className="Actions">
            {
              <Button onClick={modalDismissHandler} data-testid="dismiss-modal">Cancel</Button>
            }
            {
              <Button onClick={clearFilterHandler} theme={isFiltered && redButton} disabled={!isFiltered} data-testid="dismiss-modal">Clear</Button>
            }
            {
              <Button onClick={modalConfirmHandler} theme={hasSelectedValues() && primaryButton} disabled={!hasSelectedValues()} data-testid="confirm-modal">Filter</Button>
            }
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
};

ImpcFilterModal.propTypes = {
  modal: PropTypes.shape({
    open: PropTypes.bool,
  }),
  confirmHandler: PropTypes.func,
  dismissHandler: PropTypes.func,
  clearHandler: PropTypes.func,
  isFiltered: PropTypes.bool,
};

export default ImpcFilterModal;
